import Cookies from "js-cookie";
import helpers from "../Helpers";
import axios from "axios";

export const identifyAccosiactedTab = (url) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(url, {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const submitDeleteVideo = (video_ids, competitors = false) =>
  new Promise((resolve, reject) => {
    const queryParams = video_ids?.map((id) => `${id}`).join(",");
    const apiUrl = `${process.env.REACT_APP_DENALI_BASE_URL}/video/remove?video_ids=${queryParams}`;
    helpers
      .axiosDeleteCall(apiUrl, {
        competitors,
      })
      .then(({ response }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const submitRestoreVideo = (video_ids, competitors = false) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/videos/untrash_videos`, {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        video_ids,
        competitors,
      })
      .then(({ response }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const submitUnFlaggedVideo = (video_ids) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/videos/unflag_videos`, {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        video_ids,
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const submitUnFavoriteVideo = (video_ids) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/videos/unfavorite_videos`, {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        video_ids,
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const trashItem = (url, competitors = false, manufacturer_ids = []) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: url.includes("videos") ? "get" : "put",
      url: `${process.env.REACT_APP_BASE_URL}/jwt_api/${url}`,
      data: {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        trash: true,
        ...(competitors ? { competitors: true, manufacturer_ids } : {}),
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const markAsTrashItem = (
  url,
  competitors = false,
  manufacturer_ids = []
) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "DELETE",
      url: `${process.env.REACT_APP_DENALI_BASE_URL}/video/trash/${url}`,
      data: {
        ...(competitors ? { competitors: true, manufacturer_ids } : {}),
      },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const submitPermanentDelete = (url, product_ids) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`${url}`, {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        product_ids,
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const submitUnFavoriteProducts = (product_ids) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/products/unfavorite_products`, {
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        product_ids,
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const updateNavStats = async (newValue) => {
  try {
    const formData = new FormData();
    formData.append("ask_vyrill_intro", newValue);
    const res = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/navbar_stats`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to form data
          Authorization: "Bearer " + Cookies.get("jwt"),
        },
      }
    );

    let response = await res.data;
    return { response, res };
  } catch (error) {
    console.error("Patch API Error:", error);
    return { response: null, res: null, error };
  }
};

export const ShopifyCredentials = (requestData) => {
  axios
    .post(`${process.env.REACT_APP_BASE_URL}/jwt_api/shopify`, requestData, {
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + Cookies.get("jwt"),
      },
    })
    .then((response) => {
      console.log(response)
    })
    .catch((error) => {
      console.log(error)
    });
};
